


























































import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { ImageFile } from '@/types/image'
import { Worker } from '@/types/user'
import { StateChanger } from 'vue-infinite-loading'
import dayjs from 'dayjs'
import { EventEmitter } from 'events'
import { DeleteConfirmResults } from '@/constants/utils'

enum EventTypes {
  CONFIRM_DELETE
}

@Component({
  filters: {
    workerName: (worker: Worker) => {
      return `${worker.lastName}${worker.occupation.name}`
    },
    formatDatetime: (datetime: string) => {
      return dayjs(datetime).format('M月D日 HH:mm')
    }
  },
  components: {
    InfiniteLoading: () => import('vue-infinite-loading'),
    Loading: () => import('@/components/common/loadings/Index.vue'),
    DeleteConfirmModal: () =>
      import('@/components/common/modals/AlertModal.vue')
  }
})
export default class ImageList extends Vue {
  @Prop(String) title!: string
  @Prop({ default: () => [] }) images!: ImageFile[]
  @Prop({ default: '' }) patientName!: string

  showDeleteConfirmModal = false
  events = new EventEmitter()

  handleDeleteConfirmOk() {
    this.events.emit(EventTypes.CONFIRM_DELETE, DeleteConfirmResults.OK)
  }

  handleDeleteConfirmCancel() {
    this.events.emit(EventTypes.CONFIRM_DELETE, DeleteConfirmResults.CANCEL)
  }

  @Emit('edit')
  onClickEdit(imageId: number) {
    return imageId
  }
  @Emit('change-important')
  onClickStar(imageId: number, currentImportant: boolean) {
    return { imageId, isImportant: !currentImportant }
  }

  async onClickDelete(imageId: number) {
    this.showDeleteConfirmModal = true
    const resust = await new Promise<DeleteConfirmResults>(resolve =>
      this.events.once(EventTypes.CONFIRM_DELETE, resolve)
    )
    this.showDeleteConfirmModal = false
    if (resust === DeleteConfirmResults.CANCEL) {
      return
    }

    this.$emit('delete', imageId)
  }
  @Emit('download')
  onClickDownload(imageId: number) {
    return imageId
  }
  @Emit('next')
  onNextLoad($state: StateChanger) {
    return $state
  }
  @Emit('select-image')
  onSelectImage(imageId: number) {
    return imageId
  }

  getImportantStyle(important: boolean) {
    return important ? 'fas fa-star' : 'far fa-star'
  }

  getSenderName(image: ImageFile) {
    if (image.worker) {
      return `${image.worker.lastName}${image.worker.occupation.name}`
    }
    return this.patientName
  }
}
